import { makeStyles } from "@mui/styles";
import { BACKGROUND_COLOR } from "../../../../theme/colors";
import { INVISIBLE_SCROLL_BAR } from "../../../../utils/constants/styles";
import { BASE, BORDER, ERROR, GREY, PRIMARY, SUCCESS, WARNING } from "../../../../utils/constants/colors";
import { fontSize } from "../../../../utils/constants/UI";
import {
  SCROLL_BAR,
  fontWeight,
} from "../../../../utils/constants/UI/uiConstants";

export const styles = makeStyles({
  flex: {
    display: "flex",
  },
  campaignAuto: {
    overflow: "auto",
    ...SCROLL_BAR,
    // padding: "16px",
  },

  BORDER: { border: "1px solid #D3DAE3",borderRadius:"6px" },
  SubHeader: {
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    borderBottom: `1px solid ${BORDER.DEFAULT}`,
    width: "100%",
  },
  socialAuthIcon: {
    marginRight: "12px",
    objectFit: "contain",
    width: "clamp(1.4rem,1.7vw,3.5rem)",
    height: "clamp(1.4rem,1.2vh,2.5rem)",
  },
  socialAuthBtn: {
    fontFamily: "Roboto",
    background: "white",
    border: "1px solid #D3DAE3",
    display: "flex",
    alignItems: "center",
    fontWeight: "400",
    fontSize: fontSize.SM,
    borderRadius: "6px",
    width: "100%",
    padding: "8.5px 10px 8.5px 0px",
    justifyContent: "center",
    color: GREY.PRIMARY,
    cursor: "pointer",
  },
  pTag: {
    margin: "1rem 0rem",
  },
  Save: {
    background: "#ff4848",

    marginLeft: "0rem",
    padding: "0.7rem 1.5rem",
    border: "1px solid #ff4848",
    color: "white",
    borderRadius: "6px",
    cursor: "pointer",
    "&:hover": {
      transition: "300ms",
      background: "#ff4848",
      color: "white",
    },
  },
  hoverData:{
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    borderRadius:"6px",
    cursor:"pointer",
    padding:"2px",
    "&:hover": {
      transition: "300ms",
      background: "#ECEFF1",
      color: "white",
    },
  },
  hoverData1:{
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
  },
  materialui: {
    width: "100%",

    height: "49px !important",
    border: "1px solid #D3DAE3",
    borderRadius: "4px",
    color: "#626B7E",
    padding: "0 0.8rem",
    "@media (max-width: 1470px)": {
      border: "1px solid #D3DAE3",
    },
  },
  flexMobile: {
    display: "flex",
    paddingRight: "1rem",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      paddingRight: 0,
    },
  },
  flexJustifyBetween: {
    display: "flex",
    justifyContent: "space-between",
  },
  container: {
    margin: "16px 0px 0px 16px",
    borderRadius: "6px",
    height:"100%",
    "@media (max-width: 768px)": {
      width: "100%",
    },
  },
  title: {
    fontWeight: "600",
    color: "#102F51",
    fontSize: "20px",
    alignSelf: "center",
  },
  security: {
    background: "white",
    // padding: "16px",
    height: "100%",
    overflow: "scroll",
    borderRadius: "6px",
    ...SCROLL_BAR,
  },
  subTitle: {
    color: "#102F51",
    fontWeight: "700",
    fontSize: "15px",
    alignSelf: "center",
  },
  containEachSecurity: {
    borderRadius: "8px",

    marginRight: "1rem",
    height: "auto",

    "@media (max-width: 768px)": {
      width: "100%",
      margin: "1rem 0",
    },
  },
  dFlexSecurity:{
   display:"flex",
   flexDirection:"column",
   gap:"4px",
  },
  deleteAccountBox: {
    padding: "1.2rem",
    border: "1px solid #D3DAE3",
    borderRadius: "8px",
    margin: "1rem 0",
    width: "97.8%",
    marginRight: "1rem",
    height: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  securityInput: {
    margin: "1rem 0 0",
    width: "100%",
    border: "1px solid #D3DAE3",
    borderRadius: "4px",
    padding: "14px 17px",
    color: "#626B7E!important",
    fontWeight: "400",
    fontSize: "clamp(12px, 0.729vw, 16px)",
    "&::placeholder": {
      color: "rgba(98, 107, 126, 0.5)",
      fontSize: "clamp(12px, 0.729vw, 16px)",
      fontWeight: "400",
    },
  },
  keysInput: {
    margin: "0.2rem 0",
    display: "block",
    width: "100%",
    border: "1px solid #d3dae3",
    borderRadius: "6px",
    padding: "13px 17px",
    fontWeight: "300",
    fontSize: "14px",
  },
  keysInput1: {
    margin: "0.2rem 0",
    display: "block",
    width: "94%",
    border: "none",
    padding: "7px 10px",
    fontWeight: "300",
    fontSize: "14px",
  },
  keysInput2: {
    margin: "0.2rem 0",
    display: "block",
    width: "94%",
    border: "none",

    fontWeight: "300",
    fontSize: "14px",
  },
  deleteIcon: {
    display: "flex",
    alignItems: "center",
    padding: "0 10px",
    border: "1px solid #D3DAE3",
    background: "#fff",
    borderRadius: "6px",
    color: "#626B7E",
    height: "37px",
    cursor: "pointer",
    marginLeft: "15px",
    "&:hover": {
      backgroundColor: "#d3dae3",
    },
  },
  deleteRight: {
    marginLeft: "3px",
    marginRight: "15px",
  },
  FLEX: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    paddingTop: "4px",
  },
  paddingBtn: {
    width: "max-content",
    display: "flex",
    paddingTop: "16px",
    paddingBottom: "4px",
  },
  mxWd:{
    width: "max-content",
  },
  paddingBtnn: {
    display: "flex",
    paddingTop: "16px",
    paddingBottom: "4px",
    justifyContent: "space-between",
    gap: "8px",
  },
  WidthBox: {
    width: "50%",
  },
  sucurityBtn: {
    background: "#ff4848",
    padding: "10px 20px",
    border: "1px solid #ff4848",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "400",
    borderRadius: "6px",
    marginTop: "16px",
    cursor: "pointer",
    "&:hover": {
      transition: "300ms",
      background: "white",
      color: "#ff4848",
    },
  },
  securityPara: {
    fontWeight: "300",
    letterSpacing: "0.32px",
    color: "#626b7e",
    fontSize: "14px",
    lineHeight: "1.5",
  },
  containSecurityBoxes: {
    display: "flex",
    flexWrap: "wrap",
  },
  
  containSecurityBoxesWidth: {
    width: "40%",
    paddingLeft:"16px",
    paddingTop:"16px",
    display:"flex",
    flexDirection:"column",
    gap:"16px",

  },

  containSecurityBoxesWidth01: {
    width: "100%",
    padding: "24px",
    display:"flex",
    flexDirection:"column",
    gap:"16px",

  },
  securityPhoneBox: {
    marginRight: "0",
  },
  paddingData1: {
    padding: "10px 20px",
  },
  logoutBtn: {
    background: "#ff4848",
    padding: "10px 20px",
    border: "1px solid #ff4848",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "400",
    borderRadius: "6px",
    cursor: "pointer",
    "&:hover": {
      transition: "300ms",
      background: "white",
      color: "#ff4848",
    },
  },
  greyOutBtn: {
    background: "#D3DAE3",
    padding: "10px 20px",
    border: "1px solid #D3DAE3",
    color: "#626B7E",
    fontSize: "16px",
    fontWeight: "400",
    borderRadius: "6px",
  },
  date: {
    color: "#626b7e",
    fontSize: "10px",
    alignSelf: "center",
  },
  containPasswordheading: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: "16px",
    // paddingBottom: "10px",
  },

  // Notifications Styles

  notificationSubTitle: {
    color: "#102F51",
    fontSize: "14px",
    fontWeight: "700",
  },
  notificationPara: {
    fontWeight: "300",
    fontSize: "13px",
    width: "100%",
    lineHeight: "1.5",
    margin: "0.5rem 0",
  },
  containGetNotified: {
    padding: "1.5rem 0",
    width: "50%",
    "@media (max-width: 768px)": {
      width: "100%",
    },
  },
  containEmailSend: {
    background: "#f9fafb",
    width: "50%",
    display: "flex",
    justifyContent: "space-between",
    padding: "0 1.5rem",
    borderRadius: "6px",
    "@media (max-width: 768px)": {
      width: "100%",
      padding: "1rem",
    },
  },
  containEmail: {
    alignSelf: "center",
  },
  notifications: {
    background: "white",
    padding: "1rem 1.5rem",
    margin: "1.5rem 0",
    "@media (max-width: 768px)": {
      background: "unset",
    },
  },
  apps: {
    height:"100%",
    background: "white",
    // padding: "1rem",
    // margin: "1.5rem 0 0 0",
    marginTop: "0",
    overflow: "auto",
    ...SCROLL_BAR,
    borderRadius: "6px",
    "@media (max-width: 768px)": {
      background: "unset",
    },
  },
  notificationAction: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "0 1rem",
    borderRight: "1px solid #d3dae3",
    color: "#0B1534",
    alignSelf: "center",
    cursor: "pointer",
  },
  selectedNotificationAction: {
    fontSize: "12px",
    fontWeight: "600",
    padding: "0 1rem",
    color: "#ff4848",
    alignSelf: "center",
  },
  notificationTopics: {
    border: "1px solid #D3DAE3",
    borderRadius: "6px",
    padding: "0.5rem",
    display: "flex",
    justifyContent: "space-between",
  },
  notificationInput: {
    border: "none",
    background: BACKGROUND_COLOR,
    width: "100%",
    paddingLeft: "0.5rem",
    fontWeight: "300",
  },
  containNotificationInput: {
    background: BACKGROUND_COLOR,
    width: "20vw",
    border: "1px solid #d3dae3",
    borderRadius: "4px",
    padding: "0.5rem",
    display: "flex",
    justifyContent: "flex-start",
  },
  containNotificationTopics: {
    padding: "1rem",
    background: BACKGROUND_COLOR,
    borderRadius: "4px",
    height: "35vh",
    overflow: "scroll",
    ...INVISIBLE_SCROLL_BAR,
  },

  // Account Default Styles
  accrdionDescription: {
    color: "#616A7D",
    fontWeight: "300",
    fontSize: "14px",
    borderTop: "1px solid #F3F5F7",
    padding: "0.8rem 1rem",
  },
  accountDefaultPara: {
    fontWeight: "400",
    color: "#626B7E",
    fontSize: "14px",
    alignSelf: "center",
    background: "#F9FAFB",
    padding: "0.8rem 1.5rem",
    borderRadius: "4px",
  },
  accountDefaultFlex: {
    display: "flex",
    justifyContent: "space-between",
  },
  accountDefaultContainer: {
    background: "white",
    padding: "1rem",
    borderRadius: "4px",
    height: "82vh",
    overflow: "scroll",
    "@media (max-width: 768px)": {
      background: "unset",
    },
    ...INVISIBLE_SCROLL_BAR,
  },
  containInputs: {
    padding: "1rem 0",
    display: "flex",
    flexWrap: "wrap",
  },
  inputTitle: {
    fontWeight: "300",
    fontSize: "13px",
    color: "#102F51",
    letterSpacing: "0.6px",
    alignSelf: "center",
    marginRight: "0.4rem",
  },
  accountDefaultInput: {
    background: "white",
    border: "1px solid #D3DAE3",
    padding: "1rem",
    borderRadius: "4px",
    width: "100%",
    margin: "1rem 0",
    fontWeight: "400",
    fontSize: "12px",
  },
  containInputTitle: {
    display: "flex",
  },
  inputIcon: {
    color: "#ff4848",
    width: "16px",
    height: "16px",
  },
  eachInputBox: {
    width: "30vw",
    marginRight: "1rem",
    "@media (max-width: 768px)": {
      width: "80vw !important",
    },
  },
  redText: {
    color: "#ff4848",
    cursor: "pointer",
  },
  containKeysInput: {
    width: "100%",
  },
  scrollContainer: {
    height: "calc(100vh - 6rem)",
    // padding:"0 0 24px 0",
  },
  grid4to1: {
    display: "grid",
    gridTemplateColumns: "6fr 3fr",
  },

  /// Campaign Setting
  headerWrap: {
    padding:"16px 16px 0px 16px",
    borderBottom: "1px solid #D3DAE3",
    // paddingBottom: "1rem",
  },
  headerWrapCamp: {
    padding:"16px",
    borderBottom: "1px solid #D3DAE3",
    // paddingBottom: "1rem",
  },
  afterTitle: {
    paddingTop: "1rem",
  },
  tabData: {
    borderBottom: "2px solid red",
    borderRadius: "1px",
    height: "44px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0px 12px",
    cursor: "pointer",
  },
  tabData1: {
    // borderBottom:"2px solid red",
    // borderRadius:"1px",
    height: "44px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0px 12px",
    cursor: "pointer",
  },
  tabBody: {
    // paddingLeft:"28px",
    background: "#FFFFFF",
    height: "44px",
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  containerData: {
    background: "#FFFFFF",
    boxShadow: "0px 2px 3px rgba(98, 107, 126, 0.11)",
    borderRadius: "6px",
  },
  bodyContainer: {
    padding: "32px 32px 16px 32px",
    display: "grid",
    gridTemplateColumns: "23.7% 23.7% 23.7% 23.7%",
    gap: "10px",
  },
  bodyContainer1: {
    padding: "32px 32px 16px 32px",
    display: "grid",
    gridTemplateColumns: "23.7% 23.7% 23.7% 23.7%",
    backgroundColor:"white",
    gap: "10px",
  },
  boxContent:{
    padding:"24px",
    display:"flex",
    flexDirection:"column",
    gap:"16px",
    background: "#F8F8F8",
    borderRadius: "8px",
  },
  connectedContainer:{
    paddingTop: "1rem",
    display: "grid",
    width:"65%",
    gridTemplateColumns: "50% 50%",
    gap:"10px"
  },
  mainCont:{
    display:"flex",
    width:"100%",
    gap:"16px"
  },
  leftSectCont:{
    width:"35%",
    padding:".833vw",
    // paddingRight:"16px",
    borderRight:"1px solid #EFEFEF",
    display:"flex",
    flexDirection:"column",
    gap:"16px",

  },
  boxData: {
    padding: "1.667vw",
    background: "#F8F8F8",
    borderRadius: "8px",
    // border:"1px solid #DBDBDB",
    // width:"30%",
  },
  boxData1: {
    // padding: "1.667vw",
    background: "#FFFFFF",
    borderRadius: "8px",
    border:"1px solid #DBDBDB",
    // width:"30%",
  },
  boxData2: {
    // padding: "1.667vw",
    background: "#FFFFFF",
    borderRadius: "8px",
    border:"1px solid #DBDBDB",
    height:"175px",

    // width:"30%",
  },
  headerData: {
    borderBottom: "1px solid #D3DAE3",
    height: "70px",
    display: "flex",
    alignItems: "center",
  },
  headerText: {
    color: "#212833",
    fontWeight: "500",
    fontSize: "clamp(14px,.833vw,22px)",
  },
  bodyData: {
    display: "flex",
    flexDirection: "column",
    padding: "20px 0px 30px 30px",
  },
  bodyWithin: {
    display: "flex",
    justifyContent: "flex-start",
  },
  commonLabel: {
    color: "#212833",
    fontSize: "clamp(12px,.729vw,20px)",
    fontWeight: "500",
  },
  marginInput: {
    marginTop: "8px",
  },
  mainSeparator: {
    width: "50%",
    border: "1px solid #D3DAE3",
    borderRadius: "6px",
  },
  SEND: {
    display: "flex",
    gap: "4px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  PADDING: {
    padding: "1.5rem 1rem 1rem 1rem",
  },
  mainSeparator2: {
    width: "50%",
    border: "1px solid #D3DAE3",
    borderRadius: "6px",
    marginTop: "30px",
  },
  commonPadding: {
    padding: "1rem 1rem 1.5rem 1rem",
  },
  commonBtop: {
    borderTop: "1px solid #D3DAE3",
  },
  commonLimit: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    columnGap: "8px",
    padding: "0 1rem",
  },
  commonLimit1: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    columnGap: "8px",
  },
  boxInput: {
    width: "100%",
    border: "1px solid #D3DAE3",
    padding: "5px 5px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
  },
  Connect: {
    display: "flex",
    gap: "4px",
    alignItems: "center",
  },
  boxInput1: {
    width: "50%",
    padding: "5px 5px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
  },
  signatue: {
    "& h4": {
      fontSize: "16px",
      color: "#212833",
      fontWeight: "600",
      marginBottom: "6px",
    },
    "& p": {
      fontSize: "12px",
      fontWeight: "400",
      color: "#626B7E",
    },
  },
  paddingBtCamp:{
   padding:"16px 0px 10px 16px"
  },
  paddingBtCamp1:{
   padding:"0px 0px 0px 16px"
  },
  campaignField: {
    background: "#F8F8F8",
    borderRadius: "6px",
    padding: "16px",
    width:"73vw",
    "& label": {
      fontSize: "14px",
      color: "#212833",
      fontWeight: "500",
      marginBottom: "8px",
      display: "block",
    },
  },
  widSet:{
   width:"73.833vw",
   paddingLeft:"16px"
  },
  GAP: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  previewHeader: {
    background: GREY.QUATINARY,
    margin: "-20px -20px 20px",
    padding: "15px 20px",
    borderRadius: "6px 6px 0 0",
  },
  settingPreview: {
    background: "#fff",
    height: "100%",
    borderRadius: "6px",
    padding: "20px",
    "& h5": {
      fontWeight: "500",
      fontSize: "20px",
      color: "#212833",
    },
    "& p,& span": {
      fontSize: "14px",
      fontWeight: fontWeight.REGULAR,
      color: GREY.SECONDARY,
    },
  },
  seprator: {
    // borderTop: "1px solid #D3DAE3",
    // marginTop: "16px",
    paddingTop: "12px",
    "& textarea": {
      border: "1px solid #D3DAE3",
      borderRadius: "12px",
      height: "clamp(75px,6.250vw, 150px)",
      width: "100%",
      resize: "none",
      padding: "14px 17px",
      fontSize: "clamp(14px,0.833vw,18px)",
      color: "#626B7E",
      "&::placeholder": {
        color: "rgba(98, 107, 126, 0.5)",

        fontWeight: "400",
      },
    },
    "& h6": {
      fontSize: "14px",
      color: "#212833",
      fontWeight: "500",
    },
    "& input": {
      width: "100%",
      border: "1px solid #D3DAE3",
      borderRadius: "4px",
      padding: "14px 17px",
      color: "#626B7E",
      fontWeight: "400",
      fontSize: "clamp(14px,0.833vw,18px)",
      "&::placeholder": {
        color: "rgba(98, 107, 126, 0.5)",

        fontWeight: "400",
      },
    },
  },
  cancellbtn: {
    background: "#F7F9FB",
    padding: "10px 20px",
    borderRadius: "6px",
    border: "1px solid #D3DAE3",
    fontSize: "16px",
    fontWeight: "400",
    color: "#626B7E",
    cursor: "pointer",
    margin: "15px 0 0 0",
  },
  savebtn: {
    background: "#ff4848",
    padding: "10px 20px",
    border: "1px solid #ff4848",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "400",
    borderRadius: "6px",
    margin: "15px 0 0 0px",
    cursor: "pointer",
    "&:hover": {
      transition: "300ms",
      background: "white",
      color: "#ff4848",
    },
  },
  connectedshow: {
    borderRadius: "4px",
    border: "1px solid #D3DAE3",
    padding: "9.5px 17px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& span": {
      fontSize: "16px",
      fontWeight: "400",
      color: "#626B7E",
    },
  },
  connectGoogle: {
    background: "white",
    border: "1px solid #D3DAE3",
    display: "flex",
    alignItems: "center",
    fontWeight: "400",
    fontSize: "16px",
    borderRadius: "6px",
    width: "100%",
    height: "45px",
    color: "#626B7E",
    cursor: "pointer",
    paddingLeft: "17px",
  },
  margTopp: {
    marginTop: "2px",
    color: GREY.SECONDARY,
    fontWeight: fontWeight.REGULAR,
    fontSize: fontSize.SM,
  },
  mTop: {
   marginTop:"16px"
  },
  mBot:{
   marginBottom:"8px"
  },
  appHead: {
    display: "flex",
    justifyContent: "space-between",
    columnGap: "20px",
    paddingTop: "16px",
  },
  gmailAppHead: {
    display: "flex",
    justifyContent: "space-between",
  },
  insideBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "20px",
  },
  insideBox1: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background:"#F8F8F8",
    padding:".833vw",
    borderTopRightRadius:"8px",
    borderTopLeftRadius:"8px",
    borderBottom:"1px solid #DBDBDB",
  },
  socialAuthBtn: {
    background: "white",
    boxShadow:
      "0px 3px 4px rgba(24, 24, 28, 0.04), 0px 1px 1px rgba(24, 24, 28, 0.04)",
    border: "1px solid #E6E6E6",
    display: "flex",
    alignItems: "center",
    fontWeight: "400",
    fontSize: fontSize.SM,
    borderRadius: "6px",
    width: "100%",
    height: "36px",
    padding: "15px",
    justifyContent: "center",
    color: GREY.PRIMARY,
    cursor: "pointer",
    // fontFamily: "Roboto",
  },
  socialAuthDisable: {
    background: GREY.DISABLED,
    boxShadow:
      "0px 3px 4px rgba(24, 24, 28, 0.04), 0px 1px 1px rgba(24, 24, 28, 0.04)",
    border: "1px solid #E6E6E6",
    display: "flex",
    alignItems: "center",
    fontWeight: "400",
    fontSize: fontSize.SM,
    borderRadius: "6px",
    width: "100%",
    height: "36px",
    padding: "15px",
    justifyContent: "center",
    color: GREY.SECONDARY,
    cursor:"no-drop",
    // fontFamily: "Roboto",
  },
  socialAuthIcon: {
    marginRight: "12px",
    objectFit: "contain",
    width: "clamp(1.4rem,1.7vw,3.5rem)",
    height: "clamp(1.4rem,1vh,2.5rem)",
  },
  displayInsideData: {
    display: "flex",
    gap: "4px",
  },
  paddingTopStyle: {
    paddingTop: "1.667vw",
  },
  paddingTopStyle16: {
    paddingTop: ".833vw",
  },
  padding8ts:{
    paddingTop:"8px"
  },
  bottomStyle: {
    display: "flex",
    gap: "2.083vw",
    paddingTop: "6px",
  },
  bottomRightSect: {
    display: "flex",
    gap: "8px",
    paddingTop: "6px",
    alignItems: "center",
  },
  imgHt: {
    width: "85.6px",
    height:"20.95px",
    objectFit: "contain",
    // marginLeft:"-11px",
  },
  connInsideBox:{
    margin:".833vw",
    padding:".833vw",
    borderRadius:"6px",
    border:"1px solid #EFEFEF",
  },
  dsBtwn:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    borderBottom:"1px solid #EFEFEF",
    padding:"0 0 .833vw 0",
  },
  dsBtwn1:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    padding:".833vw 0 .833vw 0",
  },
  stschp:{
    background:"#ECEFF1",
    padding:"2px 8px",
    borderRadius:"4px",
  },
  centrData:{
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    padding:"16px"
  },

  paddingSts:{
    padding:".833vw 0 0 .833vw",
    display:"flex",
    alignItems:"center",
    gap:"4px"
  },
  padding16:{
    padding:"16px"
  },

  hrdlStyle:{
    display:"flex",
    gap:"4px",
  },
  borderRightStyl:{
    borderRight:"1px solid #EFEFEF",
    paddingRight:"4px",

  },
  widthHandle: {
    width: "100%",
  },
  inputHand: {
    display: "flex",
    // justifyContent:"space-between",
    alignItems: "center",
    gap: "6px",
  },
  padding4ts:{
    paddingTop:"4px"
  },
  menuContainer: {
    padding: ".833vw",
  },
  dispFlx: {
    display: "flex",
    justifyContent: "space-between",
    gap: "6px",
  },
  dispFlx1: {
    display: "flex",
    alignItems:"center",
    width:"100%",
    // justifyContent: "space-between",
    gap: "6px",
  },
  dspColflx: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  dspColflx1: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    width:"50%"
  },
  dspFooter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "6p",
    padding: ".833vw",
    borderTop: "1px solid #E6E6E6",
  },
  dspFooterContent: {
    display: "flex",
    gap: "4px",
    alignItems: "center",
  },
  hoverStyleFooter: {
    cursor:"pointer",
    "&:hover":{
      color:PRIMARY.W_500
    }
  },
  paddingTopStyle6: {
    paddingTop: "6px",
  },
  widthStyle:{
    width:"6vw"
  },
  imageHtWd:{
    height:"48px",
    width:"114px",
  },
  widthFix:{
    width:"105px"
  },

  ///Connected Esp Style

  connectedContainerEsp:{
    margin:"1.667vw 10vw .833vw 10vw",
    display:"flex",
    flexDirection:"column",
    gap:"16px",
  },
  bodyConnected:{
    width:"100%",
    border:"1px solid #DBDBDB",
    borderRadius:"8px",
  },
  bodyConnected1:{
    width:"100%",
    border:"1px solid #DBDBDB",
    // borderLeft:"1px solid #DBDBDB",
    // borderRight:"1px solid #DBDBDB",
    borderRadius:"8px",
    // borderTopRightRadius:"8px",

  },
  displaySpaceBetwn:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    // borderBottom:"1px solid #DBDBDB",
    padding:"16px",
  },
  displaySpaceBetwn1:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    borderBottom:"1px solid #DBDBDB",
    padding:"16px",
  },
  displaySpaceBetwnData:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    borderBottom:"1px solid #DBDBDB",
    paddingBottom:"16px",
  },
  dFlexGap:{
    display:"flex",
    alignItems:"center",
    gap:"4px"
  },
  dFlexGap1:{
    display:"flex",
    alignItems:"center",
    gap:"16px"
  },
  disSpace:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center"
  },
  disSpace2:{
    display:"flex",
    justifyContent:"space-between",
    // alignItems:"center"
  },
  disSpace1:{
    display:"flex",
    justifyContent:"flex-start",
    alignItems:"center",
    gap:"8px",
  },
  paddingStyl:{
    padding:"0 16px 16px 16px"
  },
  flxDt:{
    display:"flex",
    alignItems:"center",
    gap:"2px",
    borderRight:"1px solid #E8E8E8",
    paddingRight:"4px"
  },
  flxDt1:{
    display:"flex",
    alignItems:"center",
    gap:"2px",
  },
  optionSty:{
    display:"flex",
    flexDirection:"column",
    gap:"12px",
    padding:"8px 12px"
  },
  optionCont:{
    display:"flex",
    gap:"4px",
    alignItems:"center",
    cursor:"pointer",
    whiteSpace:"nowrap"
  },
  optionCont1:{
    display:"flex",
    gap:"4px",
    alignItems:"center",
    padding:"8px 0"
  },
  dGrid:{       
    display:"grid",
    gridTemplateColumns:"1fr 1fr"
  },
  borSet1:{
    borderRight:"1px solid #EFEFEF",
    backgroundColor:"#FFFFFF",
    borderRadius:"6px",
  },
  borSet:{
    borderRight:"1px solid #EFEFEF",
  },
  backgrdContent:{
   background: "#F8F8F8",
   padding:"16px",
   display:"flex",
   flexDirection:"column",
   gap:"8px",
   borderRadius:"0 0 6px 6px",

  },
  noRecordSty:{
    display:"flex",
    flexDirection:"column",
    gap:"6px",
    justifyContent:"center",
    alignItems:"center",
    height:"calc(100vh - 270px)"
  },
  noImageSty:{
    height:"20vh"
  },
  isPrimaryStyle:{
    backgroundColor:PRIMARY.W_50,
    padding:"2px 8px",
    borderRadius:"4px",
    
  },
  marginBottomIfErr:{
    marginBottom: "20px"
  },
  borderDataSet:{
    borderRadius:"6px",
    border:"1px solid #d3dae3"
  },
  signaturesShell: {
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  signaturesToolbar: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: "12px",
    flexWrap: "wrap",
  },
  signaturesMailboxSelector: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    width: "320px",
    maxWidth: "100%",
  },
  signaturesTableWrapper: {
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "6px",
    overflow: "hidden",
    backgroundColor: "#fff",
    // CustomTable always renders a <CustomPagination> div as the last child of
    // its root. We don't paginate this small list, so hide that footer.
    "& > div > div:last-child": {
      display: "none",
    },
  },
  signaturesTable: {
    width: "100%",
    borderCollapse: "collapse",
    "& th, & td": {
      textAlign: "left",
      padding: "10px 16px",
      borderBottom: `1px solid ${BORDER.LIGHT}`,
      verticalAlign: "middle",
    },
    "& thead th": {
      backgroundColor: BASE.BACKGROUND_LIGHT,
      fontSize: "12px",
      fontWeight: 500,
      color: GREY.SECONDARY,
      textTransform: "uppercase",
      letterSpacing: "0.04em",
    },
    "& tbody tr:hover": {
      backgroundColor: BASE.BACKGROUND_LIGHT,
    },
    "& tbody tr:last-child td": {
      borderBottom: "none",
    },
  },
  signaturesTableNameCell: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    minWidth: 0,
  },
  signaturesTableActions: {
    display: "flex",
    gap: "6px",
    justifyContent: "flex-end",
  },
  signatureList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  signatureRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    padding: "12px 16px",
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "6px",
    backgroundColor: "#fff",
    transition: "border-color 150ms ease",
    "&:hover": {
      borderColor: BORDER.HOVER,
    },
  },
  signatureRowMain: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    minWidth: 0,
    flex: 1,
  },
  signatureNameLine: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  signatureSubLine: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: GREY.SECONDARY,
  },
  signatureRowActions: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexShrink: 0,
  },
  defaultBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: SUCCESS.W_50,
    color: SUCCESS.W_600,
    padding: "2px 8px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "16px",
  },
  signaturesEmpty: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "48px 16px",
    border: `1px dashed ${BORDER.DEFAULT}`,
    borderRadius: "6px",
    textAlign: "center",
  },
  signatureFormGrid: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  signatureFormRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
  },
  signatureFormFull: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  signatureDefaultToggle: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    paddingTop: "4px",
  },
  signatureFormBody: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1.4fr) minmax(0, 1fr)",
    gap: "20px",
    "@media (max-width: 900px)": {
      gridTemplateColumns: "minmax(0, 1fr)",
    },
  },
  signatureFormColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    minWidth: 0,
  },
  signaturePreviewWrapper: {
    position: "sticky",
    top: 0,
    alignSelf: "flex-start",
    background: BASE.BACKGROUND_LIGHT,
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "6px",
    overflow: "hidden",
  },
  signaturePreviewHeader: {
    background: GREY.QUATINARY,
    padding: "12px 16px",
  },
  signaturePreviewBody: {
    background: "#fff",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    minHeight: "200px",
    "& p": {
      margin: 0,
      fontSize: "14px",
      color: GREY.SECONDARY,
    },
  },
  signaturePreviewEmpty: {
    color: GREY.TERTIARY,
    fontStyle: "italic",
  },
  signatureModeBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    padding: "10px 12px",
    background: BASE.BACKGROUND_LIGHT,
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "6px",
    flexWrap: "wrap",
  },
  signatureModeBarLeft: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    minWidth: 0,
  },
  signatureModeBarActions: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexShrink: 0,
  },
  htmlSignatureWrapper: {
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "6px",
    overflow: "hidden",
    backgroundColor: "#fff",
  },
  signatureFieldsDisabled: {
    opacity: 0.55,
    pointerEvents: "none",
    transition: "opacity 150ms ease",
  },
  htmlPreviewBox: {
    background: "#fff",
    padding: "16px",
    minHeight: "200px",
    fontSize: "14px",
    color: GREY.PRIMARY,
    "& *": {
      maxWidth: "100%",
    },
  },

  // ─── New simplified UI ────────────────────────────────────────────────
  sigPage: {
    padding: "20px 24px 32px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  sigToolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    flexWrap: "wrap",
  },
  sigToolbarLeft: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flex: 1,
    minWidth: "240px",
    maxWidth: "720px",
    flexWrap: "wrap",
  },
  sigCardList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  sigCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    padding: "14px 16px",
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "8px",
    background: "#fff",
    transition: "border-color 120ms ease, box-shadow 120ms ease",
    "&:hover": {
      borderColor: BORDER.HOVER,
      boxShadow: "0 1px 2px rgba(24,24,28,0.04)",
    },
  },
  sigCardMain: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    minWidth: 0,
    flex: 1,
  },
  sigCardTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  sigCardSubtle: {
    color: GREY.SECONDARY,
  },
  sigCardActions: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    flexShrink: 0,
  },
  sigEmptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    padding: "56px 24px",
    border: `1px dashed ${BORDER.DEFAULT}`,
    borderRadius: "8px",
    textAlign: "center",
    background: "#fff",
  },
  sigBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    background: SUCCESS.W_50,
    color: SUCCESS.W_600,
    padding: "1px 8px",
    borderRadius: "10px",
    fontSize: "11px",
    fontWeight: 500,
    letterSpacing: "0.02em",
    textTransform: "uppercase",
  },
  sigMailboxPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    background: BASE.BACKGROUND_LIGHT,
    color: GREY.SECONDARY,
    padding: "1px 8px",
    borderRadius: "10px",
    fontSize: "11px",
    fontWeight: 500,
    border: `1px solid ${BORDER.LIGHT}`,
  },

  // ─── Signature form modal ─────────────────────────────────────────────
  sigForm: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "4px 4px 8px",
  },
  sigFormSection: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  sigFormFieldGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px",
  },
  sigFormField: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    minWidth: 0,
  },
  sigSectionLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
  },
  sigEditorWrap: {
    position: "relative",
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "8px",
    background: "#fff",
    overflow: "hidden",
  },
  sigEditorEmpty: {
    position: "absolute",
    top: "12px",
    left: "16px",
    pointerEvents: "none",
    color: GREY.TERTIARY,
    fontSize: "13px",
  },
  sigExtractAction: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "8px",
    padding: "6px 8px",
    borderTop: `1px solid ${BORDER.LIGHT}`,
    background: BASE.BACKGROUND_LIGHT,
  },
  sigExtractBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "4px 12px",
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "6px",
    background: "#fff",
    color: GREY.SECONDARY,
    fontSize: "12px",
    fontWeight: 500,
    cursor: "pointer",
    lineHeight: "20px",
    transition: "border-color 120ms ease, color 120ms ease",
    "&:hover": {
      borderColor: PRIMARY.W_500,
      color: PRIMARY.W_500,
    },
    "&:disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
    },
  },
  sigDisclosure: {
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "8px",
    background: "#fff",
    overflow: "hidden",
  },
  sigDisclosureHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 14px",
    cursor: "pointer",
    userSelect: "none",
    "&:hover": {
      background: BASE.BACKGROUND_LIGHT,
    },
  },
  sigDisclosureHeaderText: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    minWidth: 0,
  },
  sigDisclosureBody: {
    padding: "8px 14px 16px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    borderTop: `1px solid ${BORDER.LIGHT}`,
  },
  sigDefaultRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    paddingTop: "4px",
  },

  // ─── Source picker ────────────────────────────────────────────────────
  sigSourcePicker: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "8px 4px",
  },
  sigSourceCardGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
    "@media (max-width: 640px)": {
      gridTemplateColumns: "1fr",
    },
  },
  sigSourceCard: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "20px",
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "10px",
    background: "#fff",
    cursor: "pointer",
    textAlign: "left",
    transition:
      "border-color 120ms ease, box-shadow 120ms ease, transform 120ms ease",
    "&:hover": {
      borderColor: PRIMARY.W_500,
      boxShadow: "0 2px 8px rgba(255,72,72,0.08)",
      transform: "translateY(-1px)",
    },
    "&:disabled": {
      opacity: 0.55,
      cursor: "not-allowed",
      transform: "none",
      boxShadow: "none",
    },
  },
  sigSourceCardIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    background: PRIMARY.W_50,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: PRIMARY.W_500,
  },

  // ─── Source-bar (after pick) ──────────────────────────────────────────
  sigSourceBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    padding: "8px 10px 8px 12px",
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "8px",
    background: BASE.BACKGROUND_LIGHT,
  },
  sigSourceBarLeft: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    minWidth: 0,
    flex: "0 1 auto",
    whiteSpace: "nowrap",
  },
  sigSourceBarChange: {
    flex: "0 0 auto",
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "4px 12px",
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "999px",
    background: "#fff",
    color: GREY.SECONDARY,
    fontSize: "12px",
    fontWeight: 500,
    cursor: "pointer",
    lineHeight: "20px",
    transition: "border-color 120ms ease, color 120ms ease",
    "&:hover": {
      borderColor: PRIMARY.W_500,
      color: PRIMARY.W_500,
    },
  },

  // ─── Custom-mode two-column body ──────────────────────────────────────
  sigCustomBody: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1.3fr) minmax(0, 1fr)",
    gap: "20px",
    alignItems: "stretch",
    "@media (max-width: 900px)": {
      gridTemplateColumns: "minmax(0, 1fr)",
    },
  },
  sigCustomFields: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    minWidth: 0,
  },
  sigCustomPreview: {
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "8px",
    overflow: "hidden",
    background: "#fff",
    height: "100%",
    alignSelf: "stretch",
  },
  sigCustomPreviewHeader: {
    background: GREY.PRIMARY,
    padding: "10px 14px",
    flexShrink: 0,
  },
  sigCustomPreviewBody: {
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    flex: 1,
    minHeight: "220px",
    "& p": {
      margin: 0,
      fontSize: "13px",
      color: GREY.SECONDARY,
      lineHeight: "20px",
    },
  },
  sigCustomPreviewEmpty: {
    color: GREY.TERTIARY,
    fontStyle: "italic",
    fontSize: "13px",
  },

  // ─── Integrations: connected-mailbox rows ─────────────────────────────
  espListHeader: {
    display: "flex",
    alignItems: "center",
    padding: "20px 24px 0",
  },
  espCountChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    background: BASE.BACKGROUND,
    border: `1px solid ${BORDER.DEFAULT}`,
    color: GREY.SECONDARY,
    fontSize: "13px",
    fontWeight: 500,
    padding: "4px 12px",
    borderRadius: "16px",
    lineHeight: "18px",
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  espCountChipNum: {
    fontWeight: 600,
    color: GREY.PRIMARY,
  },
  // Amber pill counting mailboxes that still have no signature.
  sigMissingChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    background: WARNING.W_50,
    border: `1px solid ${WARNING.W_300}`,
    color: WARNING.W_700,
    fontSize: "13px",
    fontWeight: 500,
    padding: "4px 12px",
    borderRadius: "16px",
    lineHeight: "18px",
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  sigMissingChipNum: {
    fontWeight: 600,
    color: WARNING.W_700,
  },
  // Clickable "No signature · Add one here" badge for the selected mailbox.
  sigAddBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    background: WARNING.W_50,
    border: `1px solid ${WARNING.W_300}`,
    color: WARNING.W_700,
    fontSize: "13px",
    fontWeight: 600,
    padding: "4px 12px",
    borderRadius: "16px",
    lineHeight: "18px",
    whiteSpace: "nowrap",
    flexShrink: 0,
    cursor: "pointer",
    "&:hover": {
      background: WARNING.W_100,
    },
  },
  // Soft, non-blocking warning shown under the daily-limit field.
  dailyLimitWarning: {
    display: "flex",
    alignItems: "flex-start",
    gap: "6px",
    marginTop: "6px",
    color: WARNING.W_700,
  },
  dailyLimitWarningText: {
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "16px",
    color: WARNING.W_700,
  },
  espList: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    padding: "20px 24px 32px",
  },
  espRow: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    padding: "16px 20px",
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "10px",
    background: "#fff",
    transition: "border-color 120ms ease, box-shadow 120ms ease",
    "&:hover": {
      borderColor: BORDER.HOVER,
      boxShadow: "0 2px 8px rgba(24,24,28,0.04)",
    },
  },
  espRowLogoImg: {
    height: "22px",
    width: "auto",
    maxWidth: "84px",
    objectFit: "contain",
    objectPosition: "left center",
    flexShrink: 0,
  },
  espRowIdentity: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    minWidth: 0,
    flex: 1,
  },
  espRowEmail: {
    fontSize: "15px",
    fontWeight: 600,
    color: GREY.PRIMARY,
    letterSpacing: "-0.01em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
  },
  // "Sending as" alias picker — only rendered for Gmail mailboxes that actually
  // have verified send-as aliases, so most rows never show it.
  espRowAlias: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    flexShrink: 0,
  },
  espRowAliasLabel: {
    fontSize: "11px",
    fontWeight: 500,
    color: GREY.SECONDARY,
    whiteSpace: "nowrap",
  },
  // styled like the app's small inputs: pill radius, quiet border, custom
  // chevron (the native one is what made it look off), hover/focus accents
  espRowAliasSelect: {
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    fontFamily: "inherit",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px",
    color: GREY.PRIMARY,
    border: `1px solid ${GREY.LIGHT}`,
    borderRadius: "8px",
    padding: "4px 26px 4px 10px",
    background:
      '#fff url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6"><path d="M1 1l4 4 4-4" fill="none" stroke="%23666f7b" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>\') no-repeat right 9px center',
    maxWidth: "230px",
    textOverflow: "ellipsis",
    cursor: "pointer",
    outline: "none",
    transition: "border-color .15s ease, box-shadow .15s ease",
    "&:hover": {
      borderColor: GREY.TERTIARY,
    },
    "&:focus": {
      borderColor: PRIMARY.W_500,
      boxShadow: `0 0 0 3px ${PRIMARY.W_50}`,
    },
  },
  // locked state: the chosen alias as a quiet read-only chip (lock icon + address)
  espRowAliasChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "18px",
    color: GREY.PRIMARY,
    background: GREY.HOVER || "#f4f6f8",
    border: `1px solid ${GREY.LIGHT}`,
    borderRadius: "8px",
    padding: "3px 10px",
    maxWidth: "260px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    cursor: "default",
  },
  espRowPrimaryChip: {
    display: "inline-flex",
    alignItems: "center",
    background: PRIMARY.W_50,
    color: PRIMARY.W_500,
    fontSize: "10px",
    fontWeight: 600,
    padding: "2px 8px",
    borderRadius: "10px",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    flexShrink: 0,
    lineHeight: "16px",
  },
  // Connection-state pill (dot + label) sitting next to the mailbox address.
  // The dot inherits `currentColor`, so each tone class below sets one colour.
  espRowStatusChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    fontSize: "11px",
    fontWeight: 600,
    padding: "2px 8px",
    borderRadius: "10px",
    lineHeight: "16px",
    letterSpacing: "0.02em",
    whiteSpace: "nowrap",
    textTransform: "capitalize",
    flexShrink: 0,
    cursor: "default",
  },
  espRowStatusDot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    background: "currentColor",
    flexShrink: 0,
  },
  espRowStatusOk: {
    color: SUCCESS.W_600,
    background: SUCCESS.W_50,
    border: `1px solid ${SUCCESS.W_200}`,
  },
  espRowStatusPending: {
    color: WARNING.W_700,
    background: WARNING.W_50,
    border: `1px solid ${WARNING.W_300}`,
  },
  espRowStatusBad: {
    color: ERROR.W_600,
    background: ERROR.W_50,
    border: `1px solid ${ERROR.W_200}`,
  },
  espRowStatusNeutral: {
    color: GREY.SECONDARY,
    background: BASE.BACKGROUND,
    border: `1px solid ${BORDER.DEFAULT}`,
  },
  espRowLimits: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    flexShrink: 0,
  },
  espRowLimit: {
    display: "inline-flex",
    alignItems: "baseline",
    gap: "6px",
  },
  espRowLimitLabel: {
    fontSize: "11px",
    color: GREY.TERTIARY,
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  },
  espRowLimitValue: {
    fontSize: "14px",
    fontWeight: 600,
    color: GREY.PRIMARY,
    letterSpacing: "-0.01em",
  },
  espRowDivider: {
    width: "1px",
    height: "16px",
    background: BORDER.DEFAULT,
  },
  espRowKebab: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    borderRadius: "6px",
    cursor: "pointer",
    color: GREY.SECONDARY,
    flexShrink: 0,
    "&:hover": {
      background: BASE.BACKGROUND_LIGHT,
    },
  },
  espListSkeleton: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    padding: "20px 24px",
  },
  espEmpty: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    padding: "72px 24px",
    border: `1px dashed ${BORDER.DEFAULT}`,
    borderRadius: "10px",
    margin: "20px 24px",
    textAlign: "center",
    background: "#fff",
  },

  // ─── Blacklist-style signatures table ─────────────────────────────────
  // Mirrors src/App/screens/Leads/components/CommonBlacklistTable.js so the
  // visual rhythm matches the Blacklist tab.
  blkTableShell: {
    border: "1px solid #d3dae3",
    borderRadius: "6px",
    overflow: "hidden",
    background: "#fff",
  },
  blkTableHead: {
    display: "grid",
    background: "#F3F5F7",
    padding: "14px 16px",
    fontSize: "13px",
    fontWeight: 500,
    color: "#0B1534",
    borderBottom: `1px solid ${BORDER.LIGHT}`,
  },
  blkTableHeadCell: {
    paddingRight: "12px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  blkTableBody: {
    display: "flex",
    flexDirection: "column",
  },
  blkTableRow: {
    display: "grid",
    padding: "14px 16px",
    background: "#fff",
    borderTop: `1px solid ${BORDER.LIGHT}`,
    alignItems: "center",
    "&:first-child": {
      borderTop: "none",
    },
    "&:hover": {
      background: BASE.BACKGROUND_LIGHT,
    },
  },
  blkTableCell: {
    color: "#626B7E",
    fontSize: "13px",
    fontWeight: 400,
    paddingRight: "12px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
  },
  blkTableCellName: {
    color: GREY.PRIMARY,
    fontSize: "13px",
    fontWeight: 600,
  },
  blkTableActionsCell: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  blkTableIconBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "28px",
    height: "28px",
    borderRadius: "6px",
    cursor: "pointer",
    color: GREY.SECONDARY,
    "&:hover": {
      background: "#F3F5F7",
    },
  },
  blkDefaultBadgeInline: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    background: SUCCESS.W_50,
    color: SUCCESS.W_600,
    padding: "1px 8px",
    borderRadius: "10px",
    fontSize: "10px",
    fontWeight: 600,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
  },
  blkSetDefaultLink: {
    background: "transparent",
    border: "none",
    padding: 0,
    color: PRIMARY.W_500,
    fontSize: "12px",
    fontWeight: 500,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },

  // ─── Signature image upload tile ─────────────────────────────────────
  sigImageEmpty: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    padding: "16px",
    border: `1px dashed ${BORDER.DEFAULT}`,
    borderRadius: "8px",
    background: BASE.BACKGROUND_LIGHT,
    transition: "border-color 120ms ease, background 120ms ease",
    "&:hover": {
      borderColor: PRIMARY.W_500,
      background: "#fff",
    },
  },
  sigImageFilled: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    padding: "10px 12px",
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "8px",
    background: "#fff",
  },
  sigImageThumbWrap: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    minWidth: 0,
  },
  sigImageThumb: {
    width: "44px",
    height: "44px",
    borderRadius: "6px",
    objectFit: "contain",
    background: BASE.BACKGROUND_LIGHT,
    border: `1px solid ${BORDER.LIGHT}`,
    flexShrink: 0,
  },
  sigImageMeta: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    minWidth: 0,
  },
  sigImageActions: {
    display: "flex",
    gap: "6px",
    flexShrink: 0,
  },
  sigImageHiddenInput: {
    display: "none",
  },
  sigImageUploadBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 14px",
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "999px",
    background: "#fff",
    color: GREY.SECONDARY,
    fontSize: "12px",
    fontWeight: 500,
    cursor: "pointer",
    "&:hover": {
      borderColor: PRIMARY.W_500,
      color: PRIMARY.W_500,
    },
  },
  sigImageGhostBtn: {
    background: "transparent",
    border: "none",
    padding: "4px 10px",
    borderRadius: "6px",
    cursor: "pointer",
    color: GREY.SECONDARY,
    fontSize: "12px",
    fontWeight: 500,
    "&:hover": {
      background: BASE.BACKGROUND_LIGHT,
      color: PRIMARY.W_500,
    },
  },
  sigPreviewImage: {
    display: "block",
    maxWidth: "100%",
    maxHeight: "120px",
    width: "auto",
    height: "auto",
    borderRadius: "4px",
    objectFit: "contain",
    objectPosition: "left center",
    alignSelf: "flex-start",
    margin: "6px 0",
  },

  // ─── Campaign Defaults tab bar (Signatures / Groups) ─────────────────
  campTabsBar: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "0 24px",
    borderBottom: `1px solid ${BORDER.LIGHT}`,
    background: "#fff",
  },
  campTab: {
    position: "relative",
    padding: "12px 16px",
    fontSize: "13px",
    fontWeight: 500,
    color: GREY.SECONDARY,
    cursor: "pointer",
    borderBottom: "2px solid transparent",
    marginBottom: "-1px",
    transition: "color 120ms ease, border-color 120ms ease",
    outline: "none",
    "&:hover": {
      color: GREY.PRIMARY,
    },
    "&:focus-visible": {
      color: GREY.PRIMARY,
      boxShadow: `inset 0 0 0 2px ${PRIMARY.W_500}33`,
      borderRadius: "4px",
    },
  },
  campTabActive: {
    color: PRIMARY.W_500,
    borderBottomColor: PRIMARY.W_500,
    "&:hover": {
      color: PRIMARY.W_500,
    },
  },

  // ─── Mailbox Groups screen (list + drilldown) ────────────────────────
  mgPage: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "20px 24px 32px",
  },
  mgToolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    flexWrap: "wrap",
  },
  mgToolbarLeft: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: 1,
    minWidth: "240px",
    maxWidth: "420px",
  },
  mgToolbarRight: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  mgBreadcrumb: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "13px",
    color: GREY.SECONDARY,
    fontWeight: 500,
  },
  mgBreadcrumbLink: {
    background: "transparent",
    border: "none",
    padding: "2px 4px",
    cursor: "pointer",
    color: GREY.SECONDARY,
    fontSize: "13px",
    fontWeight: 500,
    borderRadius: "4px",
    "&:hover": {
      color: PRIMARY.W_500,
      background: BASE.BACKGROUND_LIGHT,
    },
  },
  mgBreadcrumbCurrent: {
    color: GREY.PRIMARY,
    fontWeight: 600,
  },
  mgRowName: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    color: GREY.PRIMARY,
    fontWeight: 600,
    "&:hover": {
      color: PRIMARY.W_500,
    },
  },
  mgDefaultChip: {
    display: "inline-flex",
    alignItems: "center",
    background: SUCCESS.W_50,
    color: SUCCESS.W_600,
    padding: "1px 8px",
    borderRadius: "10px",
    fontSize: "10px",
    fontWeight: 600,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
  },
  mgCountChip: {
    display: "inline-flex",
    alignItems: "center",
    background: "#F3F5F7",
    color: GREY.PRIMARY,
    padding: "2px 10px",
    borderRadius: "10px",
    fontSize: "12px",
    fontWeight: 500,
  },
  mgKebab: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "28px",
    height: "28px",
    borderRadius: "6px",
    cursor: "pointer",
    color: GREY.SECONDARY,
    "&:hover": {
      background: "#F3F5F7",
    },
  },
  mgCheckboxCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  mgGroupChip: {
    display: "inline-flex",
    alignItems: "center",
    background: "#F3F5F7",
    color: GREY.PRIMARY,
    padding: "2px 10px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: 500,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  mgEmptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "48px 16px",
    border: `1px dashed ${BORDER.DEFAULT}`,
    borderRadius: "6px",
    textAlign: "center",
    background: "#fff",
  },
  mgModalBody: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  mgModalLabel: {
    fontSize: "12px",
    fontWeight: 500,
    color: GREY.QUATINARY,
    marginBottom: "2px",
  },

  // ─── Move-to-group popover (SequenceScreen pattern) ──────────────────
  mgMoveMenu: {
    display: "flex",
    flexDirection: "column",
    minWidth: "320px",
    maxWidth: "360px",
  },
  mgMoveMenuHeader: {
    padding: "12px 14px",
    borderBottom: `1px solid ${BORDER.LIGHT}`,
    fontSize: "14px",
    fontWeight: 600,
    color: GREY.PRIMARY,
  },
  mgMoveMenuSearch: {
    padding: "10px 12px",
    borderBottom: `1px solid ${BORDER.LIGHT}`,
  },
  mgMoveMenuList: {
    maxHeight: "240px",
    overflowY: "auto",
    ...SCROLL_BAR,
  },
  mgMoveMenuItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 14px",
    cursor: "pointer",
    fontSize: "13px",
    color: GREY.SECONDARY,
    "&:hover": {
      background: BASE.BACKGROUND_LIGHT,
      boxShadow: `inset 2px 0px 0px 0px ${PRIMARY.W_500}`,
      color: GREY.PRIMARY,
    },
  },
  mgMoveMenuItemActive: {
    background: "#FFF6F6",
    boxShadow: `inset 2px 0px 0px 0px ${PRIMARY.W_500}`,
    color: GREY.PRIMARY,
    fontWeight: 500,
  },
  mgMoveMenuEmpty: {
    padding: "20px 14px",
    fontSize: "12px",
    color: GREY.TERTIARY,
    textAlign: "center",
  },
  mgMoveMenuFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    padding: "10px 12px",
    borderTop: `1px solid ${BORDER.LIGHT}`,
  },
  mgMoveMenuFooterActions: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },

  // ─── Add-mailboxes popover (multi-select) ────────────────────────────
  mgAddMenuSelectAll: {
    display: "flex",
    alignItems: "center",
    padding: "8px 14px",
    background: BASE.BACKGROUND_LIGHT,
    borderBottom: `1px solid ${BORDER.LIGHT}`,
  },
  mgAddMenuItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 14px",
    cursor: "pointer",
    fontSize: "13px",
    color: GREY.PRIMARY,
    minWidth: 0,
    "&:hover": {
      background: BASE.BACKGROUND_LIGHT,
    },
  },
  mgAddMenuItemMain: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    flex: 1,
    gap: "2px",
  },
  mgAddMenuItemEmail: {
    fontSize: "13px",
    fontWeight: 500,
    color: GREY.PRIMARY,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  mgAddMenuItemMeta: {
    fontSize: "11px",
    color: GREY.SECONDARY,
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    textTransform: "capitalize",
  },
  mgGroupTag: {
    display: "inline-flex",
    alignItems: "center",
    padding: "1px 6px",
    background: "#F3F5F7",
    color: GREY.SECONDARY,
    borderRadius: "8px",
    fontSize: "10px",
    fontWeight: 500,
    textTransform: "none",
    maxWidth: "120px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  // ─── Mailbox sending-usage modal ──────────────────────────────────────
  usageModalBody: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  usageMailboxHeader: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    minWidth: 0,
  },
  usageMailboxLogo: {
    height: "20px",
    width: "auto",
    maxWidth: "76px",
    objectFit: "contain",
    objectPosition: "left center",
    flexShrink: 0,
  },
  usageMailboxEmail: {
    fontSize: "14px",
    fontWeight: 600,
    color: GREY.PRIMARY,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
  },
  usageCardsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
    "@media (max-width: 560px)": {
      gridTemplateColumns: "1fr",
    },
  },
  usageCard: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "16px",
    border: `1px solid ${BORDER.DEFAULT}`,
    borderRadius: "10px",
    background: "#fff",
  },
  usageCardHead: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  usageCardIcon: {
    width: "28px",
    height: "28px",
    borderRadius: "8px",
    background: PRIMARY.W_50,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: PRIMARY.W_500,
    flexShrink: 0,
  },
  usageProgressTrack: {
    width: "100%",
    height: "8px",
    borderRadius: "999px",
    background: BASE.BACKGROUND_LIGHT,
    overflow: "hidden",
  },
  usageProgressFill: {
    height: "100%",
    borderRadius: "999px",
    transition: "width 240ms ease",
  },
  usageStatsRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
  },
  usageStat: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    alignItems: "center",
    flex: 1,
  },
  usageStatLabel: {
    fontSize: "10px",
    color: GREY.TERTIARY,
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  },
  usageStatValue: {
    fontSize: "16px",
    fontWeight: 700,
    color: GREY.PRIMARY,
    lineHeight: "20px",
  },
  usageStatDivider: {
    width: "1px",
    alignSelf: "stretch",
    background: BORDER.LIGHT,
  },
  // "Next send allowed" status banner
  usageNextSend: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 14px",
    border: `1px solid ${BORDER.LIGHT}`,
    borderRadius: "10px",
  },
  usageNextSendIcon: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  usageNextSendText: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    minWidth: 0,
  },
  usageNextSendLabel: {
    fontSize: "10px",
    color: GREY.TERTIARY,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  },
  usageNextSendDetail: {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  // Reset windows — even two-tile grid; each tile stacks vertically so a long
  // timestamp can never collide with its label.
  usageMetaGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px",
    "@media (max-width: 480px)": {
      gridTemplateColumns: "1fr",
    },
  },
  usageMetaTile: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    padding: "12px 14px",
    border: `1px solid ${BORDER.LIGHT}`,
    borderRadius: "10px",
    background: BASE.BACKGROUND_LIGHT,
    minWidth: 0,
  },
  usageMetaTileHead: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    minWidth: 0,
  },
  usageMetaTileLabel: {
    fontSize: "11px",
    color: GREY.SECONDARY,
    fontWeight: 500,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
  },
  usageMetaTileTime: {
    fontSize: "16px",
    fontWeight: 700,
    color: GREY.PRIMARY,
    lineHeight: "20px",
    letterSpacing: "-0.01em",
  },
  usageMetaTileNote: {
    fontSize: "12px",
    fontWeight: 500,
    color: GREY.SECONDARY,
    lineHeight: "16px",
  },
  usageMetaTileChip: {
    alignSelf: "flex-start",
    display: "inline-flex",
    alignItems: "center",
    background: BASE.WHITE,
    color: GREY.SECONDARY,
    border: `1px solid ${BORDER.DEFAULT}`,
    fontSize: "11px",
    fontWeight: 500,
    padding: "1px 8px",
    borderRadius: "10px",
    lineHeight: "16px",
    whiteSpace: "nowrap",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  usageSkeleton: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  usageEmpty: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "40px 16px",
    border: `1px dashed ${BORDER.DEFAULT}`,
    borderRadius: "10px",
    textAlign: "center",
    background: "#fff",
  },
  usageEmptyIcon: {
    width: "44px",
    height: "44px",
    borderRadius: "50%",
    background: BASE.BACKGROUND_LIGHT,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: GREY.TERTIARY,
    marginBottom: "4px",
  },
});
